import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css'; // Assuming there is CSS, usually Vite injects it, but let's see.

document.addEventListener('DOMContentLoaded', () => {
  const rootElement = document.getElementById('nifst-membership-portal-root');
  if (rootElement) {
    const root = ReactDOM.createRoot(rootElement);
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  } else {
    console.log('NIFST Membership Portal: Root element not found. Shortcode might be missing.');
  }
});
